import React from "react";
import { FormattedMessage } from "react-intl";

import { useIntlLang } from "2g-intl";
import { useCookiesProvider } from "2g-cookies-provider";

export function AppFooter() {
  const { lang } = useIntlLang();
  const { show } = useCookiesProvider();
  return (
    <footer>
      <div className="b2b-AppFooter-row">
        <p>
          <strong>Výzkumný Ústav Železniční, a. s. (VUZ)</strong>
          <div>Novodvorská 1698/138b, Praha 4</div>
          <div>
            <FormattedMessage id="b2b.app-footer.phone" />: +420 241 493 135
          </div>
          <div>
            <FormattedMessage id="b2b.app-footer.ic" /> 27257258
          </div>
          <div>
            <FormattedMessage id="b2b.app-footer.registration" />
          </div>
        </p>
        <p>
          <strong>Zkušební centrum VUZ Velim</strong>
          <div>281 02 Cerhenice</div>
        </p>
        <p>
          <strong>VUZ Slovakia, s. r. o.</strong>
          <div>Seberíniho 1</div>
          <div>821 03 Bratislava – Ružinov</div>
          <div>Slovenská republika</div>
        </p>
      </div>
      <div className="b2b-AppFooter-row">
        <p></p>
        <p>© COPYRIGHT 2024 Všechna práva vyhrazena.</p>
        <p className="b2b-AppFooter-cookies">
          <a
            href={`https://www.cdvuz.cz/${
              lang == "cs" ? "" : lang + "/"
            }page/cookies`}
            target="_blank"
            rel="noreferrer"
          >
            <FormattedMessage id="b2b.app-footer.cookiesPrinciples" />
          </a>
          <a
            href={`https://www.cdvuz.cz/${
              lang == "cs" ? "" : lang + "/"
            }page/zasady-ochrany-osobnich-udaju`}
            target="_blank"
            rel="noreferrer"
          >
            <FormattedMessage id="b2b.app-footer.privacy" />
          </a>
          <a
            href="#"
            onClick={e => {
              e.preventDefault();
              show();
            }}
          >
            <FormattedMessage id="b2b.app-footer.cookiesSettings" />
          </a>
        </p>
      </div>
    </footer>
  );
}

AppFooter.propTypes = {};

export default React.memo(AppFooter);
